export const SET_FETCHING = "SET_FETCHING";
export const SET_ERROR = "SET_ERROR";
export const SET_SUCCESS = "SET_SUCCESS";
export const SET_CLOSE = "SET_CLOSE";
export const SET_CLEAR = "SET_CLEAR";
export const RESET_REQUEST = "RESET_REQUEST";
